<script setup>
import TicketsTable from '@/Pages/Dashboard/Support/Partials/TicketsTable.vue';
import { computed } from 'vue';

const props = defineProps({
  tickets: {
    type: Object,
    required: true,
  },
  filters: {
    type: Object,
    default: () => ({}),
  },
});
const pagination = computed(() => {
  const { data, ...rest } = props.tickets;

  return rest;
});
</script>

<script>
import DashboardLayout from '@/Layouts/DashboardLayout.vue';

export default {
  layout: DashboardLayout,
};
</script>

<template>
  <div class="bg-white py-5">
    <div class="container">
      <div class="flex justify-content-end">
        <inertia-link :href="route('dashboard.support.ticket.create')" class="button">
          {{ trans('__JSON__.Create ticket') }}
        </inertia-link>
      </div>
      <tickets-table :tickets="tickets.data" :pagination="pagination" :filters="filters"></tickets-table>
    </div>
  </div>
</template>
